module.exports = __webpack_public_path__ + "img/Inflammation-MELA_SpatialResearch.714f9a5c.png";